import { render, staticRenderFns } from "./footer-index.vue?vue&type=template&id=65c3e62c&scoped=true&"
import script from "./footer-index.vue?vue&type=script&lang=js&"
export * from "./footer-index.vue?vue&type=script&lang=js&"
import style0 from "../assets/less/about.css?vue&type=style&index=0&id=65c3e62c&scoped=true&lang=css&"
import style1 from "../assets/less/groundwork.css?vue&type=style&index=1&id=65c3e62c&scoped=true&lang=css&"
import style2 from "../assets/less/main.css?vue&type=style&index=2&id=65c3e62c&scoped=true&lang=css&"
import style3 from "../assets/less/swiper.min.css?vue&type=style&index=3&id=65c3e62c&scoped=true&lang=css&"
import style4 from "./footer-index.vue?vue&type=style&index=4&id=65c3e62c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3e62c",
  null
  
)

export default component.exports